<template>
  <div class="ima-sign-svg" v-html="renderedSvg" ref="svgDOM">
  </div>
</template>


<script>
import { mapState } from 'vuex'
import { renderer } from 'ima-svg-renderer'
import { stringToDOMNode } from '@/services/dom'

const { render, updatePositions } = renderer

export default {
  name: 'ima-sign-svg',
  data () {
    return {}
  },
  updated () {
    requestAnimationFrame(this.updatePositions.bind(this))
  },
  methods: {
    updatePositions () {
      updatePositions(this.$refs.svgDOM, this.labels.data)
    }
  },
  computed: {
    ...mapState(['sign', 'svg', 'labels', 'variant']),
    renderedSvg () {
      if (!this.svg.data) {
        return
      }
      const data = render({
        sign: this.sign.data,
        svg: stringToDOMNode(this.svg.data),
        labels: this.labels.data,
        slogan: this.variant.data.slogan,
        variant: this.variant.data,
        showStamp: true
      })

      requestAnimationFrame(this.updatePositions.bind(this))

      return data.svg
    }
  },
  created () {
    requestAnimationFrame(this.updatePositions.bind(this))
  }
}
</script>


<style lang="scss">
@import '../scss/settings';

.ima-sign-svg {
  cursor: default;
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/components/SignSVG.vue